import React from 'react';
import { APP_VERSION } from './../constants';

const Footer = () => {
    return (
        <footer className="py1">
            <div>
                <p>SYDNEY | ADELAIDE | BRISBANE | MELBOURNE | PERTH | NEW ZEALAND | COSTA RICA | SINGAPORE</p>
                <p>+61 2 8558 3500 | materialised.com</p>
            </div>
            <p>v{APP_VERSION}</p>
        </footer>
    );
};

export default Footer;
